import { Box } from "@chakra-ui/react";

import { IAppointmentActionResponse } from "modules/appointment/types/IAppointmentActionResponse";
import { IEReservationIntervalElement } from "modules/appointment/types/IEReservationIntervalElement";
import { useGetQueue } from "modules/queues/infrastructure/useGetQueue";

import { useGetFriendlyUrl } from "utils/hooks/useGetFriendlyUrl";

import { Modal } from "components/Modal";
import { ChakraText } from "components/ChakraText";

import { QueueName } from "../../Commons/QueueName";
import { GroupName } from "../../Commons/GroupName";
import { DateTimeTable } from "../../Commons/DateTimeTable";
import { EditAppointmentForm } from "./EditAppointmentForm";

interface IProps {
  onClose: () => void;
  isOpen: boolean;
  tokenId: string;
  appointment: IAppointmentActionResponse;
  intervalElement: IEReservationIntervalElement;
}

const EditAppointmentConfirmationModal = ({
  onClose,
  isOpen,
  tokenId,
  appointment,
  intervalElement,
}: IProps) => {
  const { friendlyUrl } = useGetFriendlyUrl();

  const { data: queue } = useGetQueue(appointment.queueId!, friendlyUrl);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      modalHeader={<ChakraText>Potwierdzenie operacji</ChakraText>}
      size="xl"
    >
      <ChakraText>Zmiany dokonujesz w ramach:</ChakraText>
      {appointment.queueId && <QueueName queueId={appointment.queueId} />}
      {appointment.groupId && <GroupName groupId={appointment.groupId} />}

      <ChakraText fontWeight="bold" mt={2}>
        Czy na pewno chcesz zmienić termin wizyty?
        <br />
        Termin bieżący zostanie automatycznie anulowany. Niepotwierdzenie
        zmiany terminu spowoduje utratę rezerwacji tj. żaden termin nie będzie
        zarezerwowany.
      </ChakraText>
      <DateTimeTable
        appointment={appointment}
        intervalElement={intervalElement}
      />
      <Box mt={4}>
        <EditAppointmentForm
          appointment={appointment}
          formFields={queue?.formFields || []}
          intervalElement={intervalElement}
          isOpen={isOpen}
          tokenId={tokenId}
          onClose={onClose}
        />
      </Box>
    </Modal>
  );
};

export { EditAppointmentConfirmationModal };
